module.exports = __webpack_public_path__ + "img/bgCouponImg.3ec290af.svg";